const { getElements } = window.BAO.Utils

class WishlistDrawer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCreate = this.handleCreate.bind(this)
    this.addToWishlist = this.addToWishlist.bind(this)

    this.checkIsInWishlist = this.checkIsInWishlist.bind(this)

    this.handleSwitchList = this.handleSwitchList.bind(this)
    this.handleSwitchCreate = this.handleSwitchCreate.bind(this)

    this.handleCart = this.handleCart.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)

    this.listeners.add(this.els.create.element, 'click', this.handleCreate)

    this.listeners.add(
      this.els['switch-list'].element,
      'click',
      this.handleSwitchList,
    )
    this.listeners.add(
      this.els['switch-create'].element,
      'click',
      this.handleSwitchCreate,
    )

    this.populateLists = this.populateLists.bind(this)

    this.externalEls.close.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose)
    })

    this.listeners.add(document, 'checkIsInWishlist', this.checkIsInWishlist)

    window.BAO.Wysh.ready().then(isReady => {
      if (isReady !== true) return

      this.checkIsInWishlist()

      window.BAO.Wysh.onChange(this.checkIsInWishlist)
    })
  }

  get isCustomer () {
    return this.hasAttribute('data-is-customer')
  }

  handleClose () {
    this.externalEls.close.elements.forEach(close => {
      close.click()
    })

    this.checkIsInWishlist()

    if (this.getAttribute('data-from-cart') === 'true') {
      this.setAttribute('data-from-cart', 'false')
      this.handleCart()
    }
  }

  async handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-drawer-external-el="trigger"]',
    )

    if (!trigger || !window.WyshApi) return

    if (trigger.hasAttribute('data-wishlist-added')) {
      window.BAO.Wysh.remove({
        productId: trigger.dataset.productId,
        variantId: trigger.dataset.variantId,
        wishlistKey: trigger.dataset.wishlistId,
      }).catch(this.wishlistError)

      return
    }

    const lists = await window.BAO.Wysh.getLists().catch(this.wishlistError)

    if (!lists) return

    if (this.isCustomer !== true || lists.length === 0) {
      this.addToWishlist(lists[0]?.wishlist_key ?? null, trigger.dataset)

      return
    }

    await window.BAO.sectionRenderer
      .fetchSingle('wishlist-drawer-product', trigger.dataset.productUrl)
      .then(res => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')

        this.els.product.element.innerHTML = myself.innerHTML

        this.setAttribute('aria-hidden', false)
      })
      .catch(() => {
        this.setAttribute('aria-hidden', true)
      })

    this.els.submit.element.setAttribute(
      'data-product-id',
      trigger.dataset.productId,
    )
    this.els.submit.element.setAttribute(
      'data-variant-id',
      trigger.dataset.variantId,
    )
    this.els.submit.element.setAttribute(
      'data-product-url',
      trigger.dataset.productUrl,
    )

    this.populateLists(lists)
  }

  populateLists (lists) {
    this.els.lists.element.innerHTML = ''

    lists.forEach((list, index) => {
      this.els.lists.element.innerHTML += `<div class="drw-Wishlist_Field">
        <input class="drw-Wishlist_Radio" type="radio" id="list${
          list.wishlist_key
        }" name="wishlist_list" value="${list.wishlist_key}"${
        index === 0 ? ' checked' : ''
      }>
        <label class="drw-Wishlist_Label fz-14_171" for="list${
          list.wishlist_key
        }">${list.name || window.theme.wishlist.title} (${list.total})</label>
      </div>`
    })

    if (lists.length === 0) {
      this.els['panel-create'].element.setAttribute('aria-hidden', false)
      this.els['panel-list'].element.setAttribute('aria-hidden', true)
      this.els['switch-list'].element.setAttribute('aria-hidden', true)
    } else {
      this.els['panel-create'].element.setAttribute('aria-hidden', true)
      this.els['panel-list'].element.setAttribute('aria-hidden', false)
      this.els['switch-list'].element.setAttribute('aria-hidden', false)
      this.els.newlist.element.value = ''
    }
  }

  handleSubmit () {
    const listChoice = getElements('[name="wishlist_list"]').find(
      el => el.checked,
    )

    this.addToWishlist(listChoice.value, this.els.submit.element.dataset, true)
  }

  handleCreate () {
    window.BAO.Wysh.createList(this.els.newlist.element.value)
      .then(newList =>
        this.addToWishlist(
          newList.wishlist_key,
          this.els.submit.element.dataset,
          true,
        ),
      )
      .catch(this.wishlistError)
  }

  handleSwitchList () {
    this.els['panel-create'].element.setAttribute('aria-hidden', true)
    this.els['panel-list'].element.setAttribute('aria-hidden', false)
  }

  handleSwitchCreate () {
    this.els['panel-create'].element.setAttribute('aria-hidden', false)
    this.els['panel-list'].element.setAttribute('aria-hidden', true)
  }

  handleCart () {
    const cartTrigger = document.querySelector('[data-drawers-trigger="cart"]')

    cartTrigger.click()
  }

  addToWishlist (wishlistKey, dataset, fromDrawer = false) {
    window.BAO.Wysh.add({
      productId: dataset.productId,
      variantId: dataset.variantId,
      wishlistKey,
    })
      .then(() => {
        const isFromCart = this.getAttribute('data-from-cart') === 'true'
        const isDrawerOpen = window.drawers?.activeDrawerKey === 'wishlist'

        if (
          fromDrawer === true ||
          (isFromCart === true && isDrawerOpen === true)
        ) {
          this.handleClose()
        } else {
          this.setAttribute('data-from-cart', 'false')
          this.checkIsInWishlist()
        }
      })
      .catch(this.wishlistError)
  }

  async checkIsInWishlist () {
    const lists = await window.BAO.Wysh.getLists().catch(this.wishlistError)

    if (!lists) return

    const productCount = window.BAO.Wysh.countItems(lists)

    this.externalEls.count.elements.forEach(countEl => {
      countEl.setAttribute('aria-hidden', productCount === 0)
      countEl.innerText = productCount
    })

    this.externalEls.trigger?.elements.forEach(el => {
      const matchedList = window.BAO.Wysh.findList(lists, el.dataset.variantId)

      if (matchedList) {
        el.setAttribute('data-wishlist-added', '')
        el.setAttribute('data-wishlist-id', matchedList.wishlist_key)
        el.removeAttribute('data-drawers-trigger')
      } else {
        el.removeAttribute('data-wishlist-added')
        el.removeAttribute('data-wishlist-id')

        if (this.isCustomer === true && lists.length > 0) {
          el.setAttribute('data-drawers-trigger', 'wishlist')
        } else {
          el.removeAttribute('data-drawers-trigger')
        }
      }

      el.setAttribute('data-wishlist-active', '')
    })
  }

  wishlistError (error) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${window.BAO.Wysh.errorMessage(error)}`)
  }
}

if (!customElements.get('wishlist-drawer')) {
  customElements.define('wishlist-drawer', WishlistDrawer)
}
